import Logo from "./Logo";
import { Link } from "react-router-dom";
import { COMPANY, SERVICES } from "../lib/site";
import { MapPin, Phone, Mail, Globe, Facebook } from "lucide-react";

export default function FooterSection() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer-section"
            className="bg-navy-deep text-slate-400"
        >
            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-12">
                <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
                    <div className="md:col-span-2">
                        <div data-testid="footer-logo">
                            <Logo dark size={46} />
                        </div>
                        <p className="mt-5 max-w-sm text-sm leading-relaxed">
                            Technology-focused services helping businesses,
                            organizations, and clients adopt practical digital
                            solutions — mobile platforms, software, networks, CCTV,
                            and Starlink connectivity.
                        </p>
                        <div className="mt-6 flex gap-3">
                            <a
                                href={COMPANY.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Lynxtech IT Solutions on Facebook"
                                className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white/5 text-slate-300 transition-colors hover:bg-brand hover:text-white"
                            >
                                <Facebook className="h-5 w-5" />
                            </a>
                            <a
                                href={COMPANY.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Official website"
                                className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-white/5 text-slate-300 transition-colors hover:bg-brand hover:text-white"
                            >
                                <Globe className="h-5 w-5" />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-white">
                            Services
                        </h3>
                        <ul className="mt-4 space-y-2.5 text-sm">
                            {SERVICES.map((s) => (
                                <li key={s.key}>
                                    <Link
                                        to={{ pathname: "/", hash: "#services" }}
                                        className="transition-colors hover:text-sky-300"
                                    >
                                        {s.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-display text-sm font-semibold uppercase tracking-wider text-white">
                            Contact
                        </h3>
                        <ul className="mt-4 space-y-3 text-sm">
                            <li className="flex items-start gap-2.5">
                                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-sky-400" />
                                <span data-testid="footer-address">
                                    {COMPANY.address}
                                </span>
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Phone className="h-4 w-4 shrink-0 text-sky-400" />
                                <a
                                    href={COMPANY.phoneHref}
                                    data-testid="footer-phone"
                                    className="transition-colors hover:text-sky-300"
                                >
                                    {COMPANY.phoneDisplay}
                                </a>
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Mail className="h-4 w-4 shrink-0 text-sky-400" />
                                <a
                                    href={COMPANY.emailHref}
                                    data-testid="footer-email"
                                    className="break-all transition-colors hover:text-sky-300"
                                >
                                    {COMPANY.email}
                                </a>
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Globe className="h-4 w-4 shrink-0 text-sky-400" />
                                <a
                                    href={COMPANY.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transition-colors hover:text-sky-300"
                                >
                                    {COMPANY.websiteDisplay}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs sm:flex-row sm:items-center">
                    <p data-testid="footer-copyright">
                        © {year} Lynxtech IT Solutions. All rights reserved.
                    </p>
                    <div className="flex gap-5">
                        <a href="#privacy" className="transition-colors hover:text-sky-300">
                            Privacy Policy
                        </a>
                        <Link to="/" className="transition-colors hover:text-sky-300">
                            Back to top
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
